import { TLocationList } from "../declarations/maps/locations";
import { TStore } from "../declarations/store";

export const selectorLocationsList = (store: TStore): TLocationList =>
store.locations.locationList || {data: [], pagination: {current: 0, pageSize: 0, lastPage: 0, total: 0}, loading: false};
